import React from 'react';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-10 md:py-20 bg-white text-center" data-id="element-63">
      <div className="container mx-auto px-4 md:px-6" data-id="element-64">
        <div className="max-w-3xl mx-auto" data-id="element-65">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-6" data-id="element-66">
            Empezá hoy a construir tu tranquilidad financiera
          </h2>
          <p className="text-sm md:text-lg text-gray-600 mb-6 md:mb-10" data-id="element-67">
            No dejes pasar otro mes sin saber a dónde va tu dinero. Ordená tus
            números, eliminá el estrés y tomá el control.
          </p>
          <Button href="https://checkout.tuvidasimple.shop/cart/44058955939942:1" className="px-8 md:px-12 py-3 md:py-4 text-sm md:text-base" data-id="element-68">
            Empezar hoy
          </Button>
        </div>
      </div>
    </section>;
}